import { useEffect } from 'react'
import type { CourseWithoutBlocks } from '@/types/course'
import { useAppDispatch } from '@/store/hooks'
import { lessonsApi } from '../../lessonsApi'

/**
 * Экраны всех уроков курса подгружаются заранее, по одному запросу за раз: переключение
 * урока тогда показывает экраны сразу, без пустой ленты и ожидания. По одному — чтобы
 * не забить очередь браузера и не упереться в ограничение частоты запросов сервера
 * (пачка параллельных запросов за уроками уже ловила 503). Подписки держатся, пока
 * открыт редактор, и снимаются на выходе.
 */
export const usePrefetchLessonBlocks = (course: CourseWithoutBlocks) => {
  const dispatch = useAppDispatch()
  const ids = course.lessons.map((l) => l.id).join(',')

  useEffect(() => {
    let cancelled = false
    const subs: { unsubscribe: () => void }[] = []
    const run = async () => {
      for (const id of ids ? ids.split(',').map(Number) : []) {
        if (cancelled) return
        const sub = dispatch(lessonsApi.endpoints.getLessonBlocks.initiate(id))
        subs.push(sub)
        // Ждём ответ (или отказ) — следующий урок только после этого.
        await Promise.resolve(sub).catch(() => undefined)
      }
    }
    // Даём сначала загрузиться тому, что на экране (курс, выбранный урок, модерация).
    const t = setTimeout(() => void run(), 1500)
    return () => {
      cancelled = true
      clearTimeout(t)
      subs.forEach((s) => s.unsubscribe())
    }
  }, [ids, dispatch])
}
